import React from 'react';
import { connect } from 'react-redux';
// Shared imports
import '../../../SharedUI/index';
// AssetsPopup imports
import AssetPickerContainer from './Container';
// Game(kit) imports
import LibraryTypeEnum from '../../../Game/Base/Library/Enums';
import { openAssetPicker, setCurrentAssetPickerItem, setTransformation } from '../../actions/assetPickerActions';
import AssetPicker from '.';

class AssetPickerLink extends React.Component {
    componentDidMount = () => {
        window.addEventListener("resize", this.onResize);
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.onResize);
    }

    onResize = () => {
        const { dispatch } = this.props;

        const transformation = this.getSizeAndPosition();

        // Open assetPicker
        dispatch(setTransformation(transformation.size, transformation.position));
    }

    onPickAsset = asset => {
        const { dispatch, onPickAsset } = this.props;
        dispatch(setCurrentAssetPickerItem(asset));
        onPickAsset(asset);
    }

    getSizeAndPosition = () => {
        const { id } = this.props;

        const margin = `5rem`;
        // Calculate height of the assetpicker
        const linkText = document.querySelector(`#${id} .link-text`);
        // Get position
        const position = linkText.getPosition();
        const dimensions = linkText.getOuterSize();
        // Get viewport height
        const windowSize = {
            width: window.innerWidth,
            height: window.innerHeight
        };

        let h = 0;
        const isAboveHalf = position.y <= windowSize.height * 0.65;
        // Determine if the picker should go up or down
        if (isAboveHalf) {
            h = windowSize.height - position.y;
        } else {
            h = windowSize.height - (windowSize.height - position.y);
        }

        // Set size
        const size = {
            height: `calc(${h}px - ${margin})`,
            width: windowSize.width * 0.2 < 250 ? '250px' : '20vw' // The minimal width of the picker is 250px to keep the items big enough to seperate
        };

        // Set position
        const pos = {
            x: `calc(${position.x}px - ${size.width} + ${dimensions.width}px)`,
            y: isAboveHalf ? `${position.y}px` : `calc(${position.y}px - ${h}px + ${margin} - ${dimensions.height}px)`
        };

        return {
            size: size,
            position: pos
        };
    }

    onPickerOpen = () => {
        const { dispatch, id, type, currentAsset, onPickerOpen, onPickerClose } = this.props;

        const transformation = this.getSizeAndPosition();

        // Open assetPicker
        dispatch(openAssetPicker(id, transformation.position, transformation.size, type, currentAsset, onPickerClose, this.onPickAsset));

        if (onPickerOpen) {
            onPickerOpen();
        }
    };

    render = () => {
        const { id, postCheckbox } = this.props;

        return (
            <div id={id} className="asset-picker-link-container" >
                <span className="link-text" onClick={this.onPickerOpen}>
                    {postCheckbox}
                </span>
                <AssetPicker/>
            </div>
        );
    };
}

AssetPickerLink.defaultProps = {
    id: '',
    type: LibraryTypeEnum.TEXTURES,
    linkText: 'meer',
    currentAsset: '',
    onPickerOpen: () => {},
    onPickerClose: () => {},
    onPickAsset: assetData => {
        console.warn('No callback has been set for AssetsPopup.handlePickAsset');
    }
};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    assetPicker: state.assetPicker
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssetPickerLink);
